import axios from "axios";
import { getEnhancedAuthHeaders } from "./auth";
const backendUrl = process.env.REACT_APP_BACKEND_URL_FOR_FRONTEND;

// GET
// Get an existing SIM card by ID
export const getSimCardById = async (simCardId) => {
  try {
    const response = await axios.get(`${backendUrl}/simcards/${simCardId}`, {
      headers: getEnhancedAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Get all sim cards with optional filters
export const getSimCards = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams
      ? `${backendUrl}/simcards?${queryParams}`
      : `${backendUrl}/simcards`;

    const response = await axios.get(url, {
      headers: getEnhancedAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// POST
// Add a new SIM card
export const addNewSimCard = async (simCardData) => {
  try {
    const response = await axios.post(`${backendUrl}/simcards`, simCardData, {
      headers: getEnhancedAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// PUT
// Update an existing SIM card
export const updateSimCard = async (simCardId, simCardData) => {
  try {
    const response = await axios.put(
      `${backendUrl}/simcards/${simCardId}`,
      simCardData,
      {
        headers: getEnhancedAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
// Hard delete a SIM card by ID
export const deleteSimCard = async (simCardId) => {
  try {
    const response = await axios.delete(`${backendUrl}/simcards/${simCardId}`, {
      headers: getEnhancedAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
